module.exports = __webpack_public_path__ + "static/media/LampOn.0fca660b.svg";